export const getStyles = (theme, isRTL) => ({
  container: {
    marginTop: -10,
    direction: isRTL ? "rtl" : "ltr",
  },
  statCard: {
    background:
      theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
    padding: "1.55rem",
    marginTop: -40,
    //marginLeft: isRTL ? 0 : 20,
    //marginRight: isRTL ? 20 : 0,
    borderRadius: "1rem",
    transition: "all 0.3s ease",
    boxShadow:
      theme === "dark"
        ? "0 0.5rem 2rem rgba(0,0,0,0.3), inset 0 0.0625rem 0 rgba(255,255,255,0.1)"
        : "0 0.5rem 2rem rgba(0,0,0,0.1)",
    backdropFilter: theme === "dark" ? "blur(0.625rem)" : "blur(0px)",
    WebkitBackdropFilter: theme === "dark" ? "blur(0.625rem)" : "blur(0px)",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.15)"
        : "1px solid rgba(0,0,0,0.05)",
    marginBottom: 70,
    cursor: "pointer",
    direction: isRTL ? "rtl" : "ltr",
  },
  welcomeTitle: {
    fontSize: "clamp(20px, 4vw, 28px)",
    fontWeight: "700",
    color: theme === "dark" ? "#fff" : "#1a1a1a",
    margin: "0 0 8px 0",
    textShadow: theme === "dark" ? "0 2px 4px rgba(0,0,0,0.3)" : "0 2px 4px rgba(0,0,0,0.1)",
    lineHeight: "1.2",
    textAlign: isRTL ? "right" : "left",
  },
  welcomeSubtitle: {
    fontSize: "clamp(14px, 2vw, 16px)",
    color: theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.7)",
    lineHeight: "1.4",
    textAlign: isRTL ? "right" : "left",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(min(200px, 100%), 1fr))",
    gap: "clamp(16px, 3vw, 24px)",
    marginBottom: "5",
  },
  statBox: {
    textAlign: "center",
    padding: "clamp(16px, 3vw, 24px)",
    background: theme === "light" ? "rgba(0,0,0,0.03)" : "rgba(255,255,255,0.05)",
    borderRadius: "12px",
    border: theme === "dark" ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.1)",
  },
  controlsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(min(250px, 100%), 1fr))",
    gap: "clamp(16px, 3vw, 24px)",
    alignItems: "end",
    marginBottom: "5",
    position: "relative",
    zIndex: 1,
  },
  controlGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "clamp(8px, 1.5vw, 12px)",
    flex: 1,
    minWidth: 0,
  },
  label: {
    color: theme === "dark" ? "rgba(255,255,255,0.9)" : "#374151",
    fontSize: "clamp(12px, 1.5vw, 14px)",
    fontWeight: "700",
    letterSpacing: "0.3px",
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    gap: "clamp(4px, 1vw, 8px)",
    flexDirection: isRTL ? "row" : "row",
    textAlign: isRTL ? "right" : "left",
  },
  input: {
    background: theme === "light" ? "#f9fafb" : "rgba(255, 255, 255, 0.05)",
    border: theme === "light"
      ? "2px solid rgba(0, 0, 0, 0.2)"
      : "2px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "clamp(10px, 1.5vw, 14px)",
    padding: "clamp(10px, 2vw, 14px) clamp(16px, 3vw, 20px)",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    fontSize: "clamp(12px, 1.5vw, 14px)",
    fontWeight: "600",
    outline: "none",
    transition: "all 0.3s ease",
    width: "100%",
    boxSizing: "border-box",
    textAlign: isRTL ? "right" : "left",
    direction: isRTL ? "rtl" : "ltr",
    backdropFilter: "blur(10px)",
    boxShadow: theme === "dark"
      ? "0 4px 20px rgba(0,0,0,0.2)"
      : "0 4px 20px rgba(0,0,0,0.05)",
  },
  select: {
    background: theme === "dark"
      ? "rgba(255,255,255,0.08)"
      : "rgba(0,0,0,0.03)",
    border: theme === "dark"
      ? "2px solid rgba(255,255,255,0.15)"
      : "2px solid rgba(0,0,0,0.1)",
    borderRadius: "clamp(10px, 1.5vw, 14px)",
    padding: "clamp(10px, 2vw, 14px) clamp(16px, 3vw, 20px)",
    color: theme === "dark" ? "#ffffff" : "#0f172a",
    fontSize: "clamp(12px, 1.5vw, 14px)",
    fontWeight: "600",
    outline: "none",
    transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    width: "100%",
    cursor: "pointer",
    backdropFilter: "blur(10px)",
    boxShadow: theme === "dark"
      ? "0 4px 20px rgba(0,0,0,0.2)"
      : "0 4px 20px rgba(0,0,0,0.05)",
    boxSizing: "border-box",
    textAlign: isRTL ? "right" : "left",
    direction: isRTL ? "rtl" : "ltr",
  },
  inputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  secondaryButton: {
    background: theme === "dark"
      ? "rgba(255,255,255,0.08)"
      : "rgba(0,0,0,0.05)",
    color: theme === "dark" ? "#ffffff" : "#374151",
    border: theme === "dark"
      ? "2px solid rgba(255,255,255,0.15)"
      : "2px solid rgba(0,0,0,0.1)",
    borderRadius: "clamp(10px, 1.5vw, 14px)",
    padding: "clamp(10px, 2vw, 14px) clamp(16px, 3vw, 24px)",
    fontSize: "clamp(11px, 1.5vw, 14px)",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "clamp(6px, 1vw, 10px)",
    transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    backdropFilter: "blur(10px)",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    minWidth: "clamp(100px, 15vw, 140px)",
    boxShadow: theme === "dark"
      ? "0 4px 20px rgba(0,0,0,0.2)"
      : "0 4px 20px rgba(0,0,0,0.05)",
    whiteSpace: "nowrap",
    flexDirection: isRTL ? "row" : "row",
  },
  primaryButton: {
    background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
    color: "white",
    border: "none",
    borderRadius: "clamp(10px, 1.5vw, 14px)",
    padding: "clamp(10px, 2vw, 14px) clamp(16px, 3vw, 24px)",
    fontSize: "clamp(11px, 1.5vw, 14px)",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "clamp(6px, 1vw, 10px)",
    transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    minWidth: "clamp(100px, 15vw, 140px)",
    justifyContent: "center",
    whiteSpace: "nowrap",
    flexDirection: isRTL ? "row" : "row",
  },
  requestItem: {
    background: theme === "dark"
      ? "rgba(255, 255, 255, 0.03)"
      : "rgba(0, 0, 0, 0.02)",
    border: theme === "dark"
      ? "2px solid rgba(255, 255, 255, 0.08)"
      : "2px solid rgba(0, 0, 0, 0.05)",
    borderRadius: "16px",
    padding: "clamp(16px, 3vw, 20px)",
    marginBottom: "16px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    direction: isRTL ? "rtl" : "ltr",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    WebkitOverflowScrolling: "touch",
  },
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    backdropFilter: "blur(8px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    animation: "fadeIn 0.3s ease",
    padding: "clamp(10px, 2vw, 20px)",
    direction: isRTL ? "rtl" : "ltr",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    WebkitOverflowScrolling: "touch",
  },
  modalContent: {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    WebkitOverflowScrolling: "touch",
    background: theme === "light"
      ? "rgba(255, 255, 255, 0.95)"
      : "rgba(30, 41, 59, 0.95)",
    padding: "clamp(20px, 4vw, 28px)",
    borderRadius: "clamp(12px, 2vw, 20px)",
    width: "min(90vw, 600px)",
    maxHeight: "85vh",
    overflowY: "auto",
    boxShadow: theme === "light"
      ? "0 10px 40px rgba(0, 0, 0, 0.15)"
      : "0 10px 40px rgba(0, 0, 0, 0.5)",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    border: theme === "dark"
      ? "1px solid rgba(255,255,255,0.15)"
      : "1px solid rgba(0,0,0,0.05)",
    boxSizing: "border-box",
    direction: isRTL ? "rtl" : "ltr",
  },
  controlsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "clamp(20px, 4vw, 32px)",
    paddingBottom: "clamp(12px, 2.5vw, 20px)",
    borderBottom: theme === "dark"
      ? "1px solid rgba(255,255,255,0.1)"
      : "1px solid rgba(0,0,0,0.1)",
    flexWrap: "wrap",
    gap: "16px",
    flexDirection: isRTL ? "row" : "row",
  },
  controlsTitle: {
    fontSize: "clamp(16px, 3vw, 20px)",
    fontWeight: "700",
    color: theme === "dark" ? "#ffffff" : "#0f172a",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "clamp(6px, 1vw, 10px)",
    letterSpacing: "0.3px",
    flexDirection: isRTL ? "row" : "row",
  },
  controlsSubtitle: {
    fontSize: "clamp(12px, 1.5vw, 14px)",
    color: theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
    margin: "4px 0 0 0",
    textAlign: isRTL ? "right" : "left",
  },
  resultsInfo: {
    fontSize: "clamp(12px, 1.5vw, 14px)",
    color: theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontWeight: "500",
    flexDirection: isRTL ? "row" : "row",
  },
  tabsContainer: {
    display: "flex",
    marginTop: -50,
    gap: "clamp(10px, 2vw, 16px)",
    marginBottom: "5%",
    marginLeft: isRTL ? 0 : "clamp(12px, 3vw, 20px)",
    marginRight: isRTL ? "clamp(12px, 3vw, 20px)" : 0,
    padding: "clamp(12px, 2.5vw, 16px)",
    background: theme === "light"
      ? "linear-gradient(135deg, rgba(248, 250, 252, 0.95), rgba(241, 245, 249, 0.98))"
      : "linear-gradient(135deg, rgba(30, 41, 59, 0.6), rgba(51, 65, 85, 0.6))",
    borderRadius: "clamp(14px, 2vw, 18px)",
    border: theme === "dark"
      ? "1.5px solid rgba(255,255,255,0.15)"
      : "1.5px solid rgba(0,0,0,0.08)",
    flexWrap: "wrap",
    flexDirection: isRTL ? "row" : "row",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
  },
  tabButton: {
    padding: "clamp(10px, 2vw, 14px) clamp(18px, 3.5vw, 28px)",
    borderRadius: "clamp(10px, 1.8vw, 14px)",
    border: "1.5px solid transparent",
    background: "transparent",
    cursor: "pointer",
    fontWeight: "700",
    fontSize: "clamp(13px, 1.8vw, 15px)",
    transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
    color: theme === "dark" ? "rgba(255,255,255,0.65)" : "rgba(26,26,26,0.65)",
    letterSpacing: "0.4px",
    textTransform: "capitalize",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    position: "relative",
    overflow: "hidden",
    whiteSpace: "nowrap",
    flexDirection: isRTL ? "row" : "row",
  },
  activeTabButton: {
    background: "linear-gradient(135deg, #2e7cba 0%, #2e7cba 100%)",
    color: "white",
    border: "1.5px solid rgba(46, 124, 186, 0.4)",
    fontWeight: "800",
    letterSpacing: "0.5px",
    position: "relative",
  },
  textarea: {
    width: "100%",
    minHeight: "120px",
    background: theme === "light" ? "#f9fafb" : "rgba(255, 255, 255, 0.05)",
    border: theme === "light"
      ? "1px solid rgba(0, 0, 0, 0.2)"
      : "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "12px",
    padding: "12px",
    fontSize: "14px",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    outline: "none",
    resize: "vertical",
    fontFamily: "inherit",
    textAlign: isRTL ? "right" : "left",
    direction: isRTL ? "rtl" : "ltr",
  },
  errorAlert: {
    background: "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(220, 38, 38, 0.08))",
    border: "2px solid rgba(239, 68, 68, 0.3)",
    borderRadius: "16px",
    padding: "20px",
    color: "#ef4444",
    fontSize: "15px",
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "20px",
    flexDirection: isRTL ? "row" : "row",
  },
});